import { render, staticRenderFns } from "./MediaAndText.vue?vue&type=template&id=f2796c2e&scoped=true"
import script from "./MediaAndText.vue?vue&type=script&lang=js"
export * from "./MediaAndText.vue?vue&type=script&lang=js"
import style0 from "./MediaAndText.vue?vue&type=style&index=0&id=f2796c2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2796c2e",
  null
  
)

export default component.exports